import { Transform } from "class-transformer";
import { toEuros } from "@/utils/numberUtils";

export class DeliveryNotesTotalDto {
  @Transform(({ value }) => toEuros(value))
  total: string;
}
